<template>
    <div>
        <q-table
            ref="table"
            :data="modules"
            :columns="columns_modules"
            row-key="id"
            :pagination.sync="pagination_modules"
            @request="requestModules"
            :loading="loading"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            class="q-mt-lg"
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props">
                    <q-td key="title" :props="props">
                        {{ props.row.title }}
                    </q-td>

                    <q-td key="module_score" :props="props">
                        {{ props.row.module_score }}
                    </q-td>

                    <q-td key="qty_views" :props="props">
                        {{ props.row.qty_views }}
                    </q-td>

                    <q-td key="status" :props="props" auto-width>
                        <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width text-center">
                            {{ $t(getTextStatusModule(props.row.status)) }}
                        </q-chip>
                    </q-td>

                    <q-td auto-width key="actions" :props="props">
                        <q-btn flat round color="secondary" icon="fas fa-users" @click="showModuleUsers(props.row)" >
                            <q-tooltip>
                                {{ $t('participants_report_tooltip') }}
                            </q-tooltip>
                        </q-btn>
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <q-modal v-model="show_module_users" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_module_users = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ module.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <q-table
                        ref="table"
                        :data="users"
                        :columns="columns_users"
                        row-key="user_id"
                        :pagination.sync="pagination_users"
                        @request="requestUserModules"
                        :loading="loading"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[5,10,50,100]"
                        :filter=filter_users
                        binary-state-sort
                        class="q-mt-lg"
                        >

                        <template slot="top" slot-scope="props" :props="props">
                            <q-search v-model="filter_users" icon="fas fa-search" :placeholder="$t('search')" :debounce="500" />

                            <div class="col" />
                        </template>

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <template slot="body" slot-scope="props">
                            <q-tr :props="props">
                                <q-td key="full_name" :props="props">
                                    {{ props.row.full_name }}
                                </q-td>

                                <q-td key="email" :props="props">
                                    {{ props.row.email }}
                                </q-td>

                                <q-td key="watch_date" :props="props">
                                    {{ fDate(props.row.watch_date) }}
                                </q-td>

                                <q-td key="module_score" :props="props">
                                    {{ props.row.module_score }}
                                </q-td>

                                <q-td key="status" :props="props" auto-width>
                                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width text-center">
                                        {{ $t(getTextStatus(props.row.status)) }}
                                    </q-chip>
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    name: 'TrainingReportModulesTab',

    props: ['load', 'id'],

    data() {
        return {
            pagination_modules: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            pagination_users: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns_modules: [
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'module_score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'module_score',
                    sortable: true,
                },
                {
                    name: 'qty_views',
                    required: true,
                    label: 'visualizations',
                    align: 'left',
                    field: 'qty_views',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'left',
                    field: 'actions',
                    sortable: false,
                }
            ],
            columns_users: [
                {
                    name: 'full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'full_name',
                    sortable: true,
                },
                {
                    name: 'email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'email',
                    sortable: true,
                },
                {
                    name: 'watch_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'watch_date',
                    sortable: true,
                },
                {
                    name: 'module_score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'module_score',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                }
            ],
            modules: [],
            users: [],
            module: {},
            show_module_users: false,
            loading: false,
            filter_users: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestModules({ pagination }) {
            this.loading = true
            this.pagination_modules = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination_modules.rowsPerPage,
                "page": this.pagination_modules.page,
                "ordering": order_by
            }

            this.savePaginationModules()

            this.$axios.get(`/admin_group_trainings/group_trainings/${this.id}/group_training_modules/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination_modules.rowsNumber = response.data.count

                this.modules = response.data.results.map(e => {
                    return { ...e, actions: e.id }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        requestUserModules({ pagination }) {
            this.loading = true
            this.pagination_users = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination_users.rowsPerPage,
                "page": this.pagination_users.page,
                "ordering": order_by,
                "search": this.filter_users
            }

            this.savePaginationUsers()

            this.$axios.get(`/admin_group_trainings/group_trainings/${this.id}/group_training_module_user_watch/${this.module.id}/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination_users.rowsNumber = response.data.count

                this.users = response.data.results.map(e => {
                    return { ...e }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        showModuleUsers(row) {
            this.module = row
            this.show_module_users = true

            this.requestUserModules({
                pagination: this.pagination_users
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        getTextStatusModule(status) {
            if (status === 1) return 'published_f'
            else if (status === 2) return 'unpublished_f'
        },

        getTextStatus(status) {
            if (status === 1) return 'watched'
            else if (status === 2) return 'restarted'
            else return 'pending'
        },

        getColorStatus(status) {
            if (status === 1) return 'positive'
            else if (status === 2) return 'negative'
            else return 'tertiary'
        },

        getIconStatus(status) {
            if (status === 1) return 'fas fa-check'
            else if (status === 2) return 'fas fa-times'
            else return 'far fa-clock'
        },

        savePaginationModules() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_modules.rowsPerPage])
        },

        savePaginationUsers() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_users.rowsPerPage])
        },

        loadPagination() {
            this.pagination_modules.rowsPerPage = this.num_rows
            this.pagination_users.rowsPerPage = this.num_rows
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestModules({ pagination: this.pagination_modules })
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.requestModules({ pagination: this.pagination_modules })
    }
}
</script>

<style>

</style>
